import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import useDictionary from '@ui/hooks/useDictionary';
import ButtonComponent from '@ui/components/Button/Button.component';
import DateFilterComponent from '@ui/components/Date-filter/Date-filter.component';
import AutocompleteComponent from '@ui/components/Autocomplete/Autocomplete.component';
import SelectComponent from '@ui/components/Select/Select.component';
import SwitchComponent from '../Device-settings/Switch.component';
import { IProps } from './IProps';
import { variants } from '@ui/components/Autocomplete/variants.enum';

const Component: React.FC<IProps> = ({
    devices,
    fromDateFilterCurrent,
    toDateFilterCurrent,
    dateFilter,
    lang,
    selectedDevice,
    trackMode,
    timezone,
    onFromDateChange,
    onToDateChange,
    onDateFilterChange,
    onDeviceChange,
    onSwitchTrackMode,
    onUpdateClick,
    onSettingsOpen,
}: IProps) => {
    const dateFilters = useMemo(() => {
        let dateFilterComponent: React.ReactElement;
        const dateFiltersList = [
            'last24Hours',
            'last3Days',
            'lastWeek',
            'customDate',
        ];
        if (dateFilter === 'customDate') {
            dateFilterComponent = (
                <DateFilterComponent
                    lang={lang}
                    timezone={timezone}
                    fromDateFilter={fromDateFilterCurrent}
                    toDateFilter={toDateFilterCurrent}
                    onFromDateChange={onFromDateChange}
                    onToDateChange={onToDateChange}
                />
            );
        } else dateFilterComponent = <></>;
        return (
            <>
                <SelectComponent
                    name="date-filter"
                    lang={lang}
                    value={dateFilter}
                    values={dateFiltersList}
                    variant={variants.sidebar}
                    onChange={onDateFilterChange}
                />
                {dateFilterComponent}
            </>
        );
    }, [
        dateFilter,
        lang,
        timezone,
        fromDateFilterCurrent,
        toDateFilterCurrent,
        onFromDateChange,
        onToDateChange,
        onDateFilterChange,
    ]);

    return (
        <>
            <Box className="support" component="section">
                <FormControl className="support__form" component="form">
                    <AutocompleteComponent
                        label="device"
                        name="device"
                        lang={lang}
                        value={selectedDevice}
                        values={devices}
                        variant={variants.sidebar}
                        onChange={onDeviceChange}
                    />
                    {dateFilters}
                    <Box className="support__switch-wrap">
                        <SwitchComponent
                            alarmState={trackMode}
                            name={'trackMode'}
                            onAlarmStateChange={onSwitchTrackMode}
                        />
                        <ButtonComponent
                            label="update"
                            lang={lang}
                            onClick={onUpdateClick}
                        />
                    </Box>
                    <Box className="support__settings-wrap">
                        <ButtonComponent
                            label="settings"
                            lang={lang}
                            onClick={onSettingsOpen}
                        />
                    </Box>
                </FormControl>
            </Box>
        </>
    );
};

const SupportComponent = React.memo(Component);

export default SupportComponent;
